export const APP_ROUTES = {
    ACCESS_DENIED:        'access-denied',
    FORBIDDEN_BETRIEBE:   'forbidden-betriebe',
    NOT_FOUND:            'not-found',
    ERROR:                'error',
    ORDNER:               'ordner/:ordner',
    NACHRICHT_ANZEIGEN:   'ordner/:ordner/nachricht/:nachrichtId',
    NEU:                  'neu',
    NEU_VORBELEGT:        'neu-vorbelegt',
    ANTWORT:              'antwort/:nachrichtId',
    ENTWURF:              'entwurf/:nachrichtId',
    KEIN_ONLINE_ZUGRIFF:  'kein-online-zugriff',
    SUCCESS:              'erfolgreich/:successType'
} as const;
